<template>
    <div class="h-screen w-full bg-blue flex pt-4 md:pt-0 md:items-center justify-center fixed pin-t pin-l">
        <div class="max-w-sm w-full mx-2">
            <div class="flex justify-center pb-4 md:pb-8 mb-4 md:mb-8">
                <logo style="max-width:120px"></logo>
            </div>
            <form @submit.prevent="submit">

                <form-group label="Username" name="username" :invert="true" :required="true">
                    <input type="text" name="username" id="username" class="input input--invert text-white"
                           v-model="username">
                </form-group>

                <form-group label="Password" name="password" :invert="true" :required="true">
                    <input type="password" name="password" id="password" class="input input--invert text-white"
                           v-model="password">
                </form-group>

                <div class="flex py-4 md:py-8 items-center flex-col md:flex-row">
                    <div class="flex-1 mb-4 md:mb-0">
                        <label class="checkbox checkbox--invert">
                            <input type="checkbox">
                            <span>Remember me</span>
                        </label>
                    </div>
                    <div class="flex-1 text-right">
                        <button class="text-white bg-secondary px-8 py-4 font-bold uppercase" type="submit">Log In
                        </button>
                    </div>
                </div>
            </form>

            <div class="flex justify-center">
                <router-link tag="span" class="" :to="{ name: 'password-reset' }">
                    <a href="#" class="text-white text-sm hover:text-white hover:underline">Reset password</a>
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import auth from '../auth'

export default {
    data() {
        return {
            username: null,
            password: null,
        }
    },

    methods: {
        submit() {
            auth.login(this.username, this.password, (loggedIn, errors) => {
                if (errors) {
                    this.$store.commit('setErrors', {errors: errors});
                }
                if (loggedIn) {
                    this.$store.dispatch('fetchEmployee');
                    this.$store.dispatch('fetchEmployeeExtended');
                    this.$store.commit('clearErrors');
                    this.$router.replace(this.$route.query.redirect || '/');
                }
            })
        }
    },
}
</script>
